import React from 'react'
import { commodityColors } from '../Helpers';

export const renderCommodityLegend = (commodities, siteFilters, setSiteFilters) => {
	return (
		<div id="commodityLegend">
			{commodities.map((commodity) => (
				<div
					key={commodity.id}
					className="d-flex align-items-center mb-1"
					onClick={() =>
						setSiteFilters((prev) => ({
							...prev,
							commodityFilter:
								prev.commodityFilter === commodity.id ? '' : commodity.id
						}))
					}
					title={
						siteFilters.commodityFilter === commodity.id
							? 'Click to remove this filter'
							: `Click to only see ${commodity.symbol} sites`
					}
				>
					<div
						style={{
							width: '12px',
							height: '12px',
							borderRadius: '50%',
							backgroundColor: commodityColors[commodity.id],
							marginRight: '8px'
						}}
					/>
					<span
						style={{
							cursor: 'pointer',
							fontWeight:
								siteFilters.commodityFilter === commodity.id ? 'bold' : 'normal'
						}}
					>
						{commodity.symbol || 'unknown'}
					</span>
				</div>
			))}
		</div>
	);
};
